import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CompensationQuery from 'buyside/graphql/queries/CompensationSubmissionCompensation.graphql';
import CurrentUserQuery from 'buyside/graphql/queries/CompensationSubmissionCurrentUser.graphql';
import CreateCompensationMutation from 'buyside/graphql/mutations/CreateCompensation.graphql';
import UpdateCompensationMutation from 'buyside/graphql/mutations/UpdateCompensation.graphql';

import CompensationEditPage from 'buyside/components/presentation/CompensationSubmissionPage/compensationEditPage';

const CompensationEditContainer = ({ id }) => {
  return (
    <Query query={CurrentUserQuery}>
      {({ loading: currentUserLoading, error: userError, data: userData = {} }) => {
        return (
          <Query query={CompensationQuery} variables={{ id }}>
            {({ loading: compensationLoading, error: compensationError, data: compData = {} }) => {
              return (
                <Mutation mutation={CreateCompensationMutation}>
                  {mutate => {
                    const createCompensation = args => mutate({ variables: args });
                    return (
                      <Mutation mutation={UpdateCompensationMutation}>
                        {mutate => {
                          const updateCompensation = args => mutate({ variables: args });
                          return (
                            <CompensationEditPage
                              currentUserLoading={currentUserLoading}
                              userError={userError}
                              currentUser={userData.currentUser}
                              compensationLoading={compensationLoading}
                              compensationError={compensationError}
                              compensation={compData.compensation}
                              createCompensation={createCompensation}
                              updateCompensation={updateCompensation}
                            />
                          );
                        }}
                      </Mutation>
                    );
                  }}
                </Mutation>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

export default CompensationEditContainer;
